import {
  GetForeignCurrencyHistoryParams,
  GetForeignCurrencyHistoryResponse,
  PatchCancelForeignCurrencyBody,
  PostForeignCurrencyBody,
} from '@/types/fx.type';
import api from '..';

export const postForeignCurrency = async (body: PostForeignCurrencyBody) => {
  const res = await api.postAxios<null, PostForeignCurrencyBody, null>(
    '/user/foreign-currency',
    body,
  );
  return res.status;
};

export const patchCancelForeignCurrency = async (
  body: PatchCancelForeignCurrencyBody,
) => {
  const res = await api.patchAxios<null, PatchCancelForeignCurrencyBody, null>(
    '/user/foreign-currency',
    body,
  );
  return res.status;
};

export const getForeignCurrencyHistory = async (
  params: GetForeignCurrencyHistoryParams,
) => {
  const res = await api.getAxios<
    GetForeignCurrencyHistoryResponse,
    GetForeignCurrencyHistoryParams
  >('/user/foreign-currency', params);
  return res.data;
};
